import { CustomerPremierPartnerServiceConfigurationDTO } from "../DTO/customerPremierPartnerServiceConfigurationDTO";
import { BasicRequest } from "./basicRequest";

export class UpdateCustomerPremierPartnerServiceConfigurationRequest extends BasicRequest{

    public premierServiceConfiguration!: CustomerPremierPartnerServiceConfigurationDTO;

    constructor(){
        super();
    }
}